import React, { useContext, useMemo } from 'react';

import { SidebarContent } from '../../../../types';
import { NavigationContext } from '../../../context/NavigationContext';
import { isPageSelected } from '../../../utils';
import { NavigationCategory } from '../../NavigationCategory';
import { NavigationItem } from '../../NavigationItem';

interface Props {
  title: string | null;
  sidebarPages: SidebarContent;
  pathname: string;
  depth?: number;
  defaultExpanded?: boolean;
  collapsible?: boolean;
}

export const Category: React.FC<Props> = ({
  title,
  sidebarPages,
  pathname,
  depth = 0,
  defaultExpanded,
  collapsible,
}) => {
  const { open, closeNavigation } = useContext(NavigationContext);

  const handleClick = () => {
    if (open) closeNavigation();
  };

  const active = useMemo(() => {
    let activePath = '';

    // recursively test if the current page is somewhere in the nested category
    const recursive = (pages: SidebarContent) => {
      pages.forEach(page => {
        if ('path' in page) {
          if (isPageSelected(page.path, pathname)) {
            activePath = page.path;
          }
        } else if ('pages' in page) {
          recursive(page.pages);
        }
      });
    };

    recursive(sidebarPages);

    return Boolean(activePath);
  }, [sidebarPages]);

  return (
    <NavigationCategory
      title={title || undefined}
      active={active}
      defaultOpen={defaultExpanded}
      collapsible={collapsible}
      depth={depth}
    >
      {sidebarPages.map(page => {
        if ('path' in page) {
          return (
            <NavigationItem
              key={page.title}
              anchor={page.anchor}
              path={page.path}
              title={page.title}
              active={isPageSelected(page.path, pathname)}
              onClick={handleClick}
            />
          );
        }

        return (
          <Category
            key={page.title}
            title={page.title}
            defaultExpanded={page.defaultExpanded}
            collapsible={page.collapsible}
            sidebarPages={page.pages}
            pathname={pathname}
            depth={depth + 1}
          />
        );
      })}
    </NavigationCategory>
  );
};
